"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrapeLinkCandidatesWorkflowOutputSchema = exports.LinkCandidateSchema = exports.ScrapeLinkCandidatesWorkflowInputSchema = exports.SCRAPE_LINK_CANDIDATES_WORKFLOW_NAME = void 0;
const zod_1 = require("zod");
exports.SCRAPE_LINK_CANDIDATES_WORKFLOW_NAME = 'scrapeLinkCandidatesWorkflow';
exports.ScrapeLinkCandidatesWorkflowInputSchema = zod_1.z.object({
    url: zod_1.z.string(),
    timeoutMs: zod_1.z.number().optional(),
});
exports.LinkCandidateSchema = zod_1.z.object({
    text: zod_1.z.string(),
    href: zod_1.z.string(),
});
exports.ScrapeLinkCandidatesWorkflowOutputSchema = zod_1.z.object({
    statusCode: zod_1.z.number(),
    finalUrl: zod_1.z.string(),
    title: zod_1.z.string(),
    contentType: zod_1.z.string().optional(),
    links: zod_1.z.array(exports.LinkCandidateSchema),
});
//# sourceMappingURL=scrape-link-candidates.contract.js.map